import { useEffect, useState } from 'react';

export const useTableOneShotAnimation = (): { animated: boolean } => {
  const [animated, setAnimated] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setAnimated(false);
    }, 1000);
  }, []);

  return { animated };
};
